import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { bildirimAPI, epostaAPI } from '../../api/api';
import './PostaKutusu.css';
import { onayla } from '../../utils/onayla';

/*
  POSTA KUTUSU — ust cubuktaki zarf dugmesi
  -----------------------------------------
  NEDEN AYRILDI: gelen postalar bildirim canina dusuyordu. Sayilari cok
  oldugu icin durusma, masraf talebi ve muvekkil hareketi gibi IS
  GEREKTIREN bildirimleri listenin altina itiyorlardi. Kullanici
  2026-09-28'de postalarin canin yanindaki ayri bir dugmeden
  gorulmesini istedi.

  KIME GORUNUR: yalnizca posta kutusuna erisimi olan kullaniciya
  (sunucu OzelDosyaAccess'e bakiyor ve digerlerine 0 donuyor). Sayi
  sifirsa dugme hic gosterilmiyor -- ust cubukta yer kaplamasin.
*/

const ARALIK_MS = 3 * 60 * 1000;   // her 3 dakikada bir tazele

const tarihYaz = (t) => {
  if (!t) return '';
  try {
    return new Date(t).toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit' });
  } catch (e) {
    return '';
  }
};

const PostaKutusu = () => {
  const [adet, setAdet] = useState(0);
  const [postalar, setPostalar] = useState([]);
  const [idler, setIdler] = useState([]);
  const [temizleniyor, setTemizleniyor] = useState(false);
  const [acik, setAcik] = useState(false);
  const kutuRef = useRef(null);
  const navigate = useNavigate();

  const tazele = useCallback(async () => {
    try {
      const d = await bildirimAPI.postaSayisi();
      setAdet(d?.adet ?? 0);
      setPostalar(d?.postalar ?? []);
      setIdler(d?.idler ?? []);
    } catch (e) {
      // Posta kutusu okunamazsa ust cubuk calismaya devam etmeli.
    }
  }, []);

  useEffect(() => {
    tazele();
    const z = setInterval(tazele, ARALIK_MS);
    return () => clearInterval(z);
  }, [tazele]);

  // Disariya tiklayinca kapansin.
  useEffect(() => {
    if (!acik) return undefined;
    const disari = (e) => {
      if (kutuRef.current && !kutuRef.current.contains(e.target)) setAcik(false);
    };
    document.addEventListener('mousedown', disari);
    return () => document.removeEventListener('mousedown', disari);
  }, [acik]);

  // Bekleyen posta yoksa dugme hic gosterilmiyor.
  if (adet === 0) return null;

  const tumunuAc = () => {
    setAcik(false);
    navigate('/gelen-postalar');
  };

  /*
    TUMUNU OKUNDU YAP
    Postalari "yoksayildi" durumuna alir; kayitlar SILINMEZ, posta
    kutusunun "Yoksayilanlar" bolumunde durmaya devam eder. Geri
    alinabilir oldugu icin guvenli, ama 60'tan fazla kayda tek dokunusla
    islem yaptigi icin once onay soruluyor.
  */
  const tumunuOkunduYap = async () => {
    if (idler.length === 0) return;
    const onay = await onayla(
      `${adet} posta okundu olarak işaretlenecek.\n\n`
      + 'Postalar silinmiyor; posta kutusunun "Yoksayılanlar" bölümünde kalmaya devam edecek.\n\n'
      + 'Devam edilsin mi?'
    );
    if (!onay) return;

    setTemizleniyor(true);
    try {
      await epostaAPI.yoksayToplu(idler);
      await tazele();
      setAcik(false);
    } catch (e) {
      window.alert('İşaretlenemedi. Lütfen tekrar deneyin.');
    } finally {
      setTemizleniyor(false);
    }
  };

  return (
    <div className="pk-sarmal" ref={kutuRef}>
      <button
        type="button"
        className="pk-dugme"
        onClick={() => setAcik((o) => !o)}
        aria-label={`Posta kutusu, ${adet} bekleyen`}
        title={`${adet} bekleyen posta`}
      >
        <svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor"
             strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="5" width="18" height="14" rx="2" />
          <path d="m3 7 9 6 9-6" />
        </svg>
        <span className="pk-rozet">{adet > 99 ? '99+' : adet}</span>
      </button>

      {acik && (
        <div className="pk-panel" role="dialog" aria-label="Bekleyen postalar">
          <div className="pk-ust">
            <strong>Bekleyen postalar</strong>
            <div className="pk-ust-sag">
              <span className="pk-sayi">{adet}</span>
              <button
                type="button"
                className="pk-temizle"
                onClick={tumunuOkunduYap}
                disabled={temizleniyor}
              >
                {temizleniyor ? 'İşleniyor…' : 'Tümünü okundu yap'}
              </button>
            </div>
          </div>

          <ul className="pk-liste">
            {postalar.map((p) => (
              <li key={p.id}>
                <button type="button" onClick={tumunuAc}>
                  <span className="pk-konu">{p.konu || '(konusuz)'}</span>
                  <span className="pk-alt">
                    {p.gonderen || ''}{p.gonderen && p.tarih ? ' · ' : ''}{tarihYaz(p.tarih)}
                  </span>
                </button>
              </li>
            ))}
          </ul>

          <button type="button" className="pk-tumu" onClick={tumunuAc}>
            Posta kutusunu aç
          </button>
        </div>
      )}
    </div>
  );
};

export default PostaKutusu;
